import styled from 'styled-components';
import { getAlertBackgroundColor } from '../utils/alertHelpers';

export const StyledAlert = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  border-radius: 8px;
  background-color: ${(props) => getAlertBackgroundColor(props.variant, props.theme)};
  color: #ffffff;
  margin-bottom: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Alert/components/AlertStyles.js